module.exports = __webpack_public_path__ + "img/1572652844.00274502.jpg";